<template>
  <div style="padding-top: 15px">
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-sm-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              <div
                class="row table-responsive"
                style="padding-bottom: 60px; margin: 0 !important"
              >
                <div style="display: flex">
                  <el-upload
                    class="upload-demo"
                    action="#"
                    style="margin-left: 10px"
                    :http-request="uploadFile"
                    :auto-upload="true"
                    accept=".xlsx, .xls"
                    :show-file-list="false"
                  >
                    <el-button type="primary" @click="submissionTypeC(1)"
                      >Online Upload</el-button
                    >
                  </el-upload>

                  <el-upload
                    class="upload-demo"
                    action="#"
                    style="margin-left: 10px"
                    :http-request="uploadFile"
                    :auto-upload="true"
                    accept=".xlsx, .xls"
                    :show-file-list="false"
                  >
                    <el-button type="primary" @click="submissionTypeC(2)"
                      >Physical Upload</el-button
                    >
                  </el-upload>
                </div>
              </div>
            </div>
  <!-- v-if='false' -->
            <template>
              <div class="title">
              <div class="row wrapper border-bottom white-bg page-heading content-wrap">
                <div class="col-sm-10">
                  <h2 class='margin'>Batch Upload</h2>
                  <el-breadcrumb >
                    <el-breadcrumb-item >Batch Upload</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </div>
            </div>

            <div class="ibox-content">
              <div
                class="row table-responsive"
                style="padding-bottom: 60px; margin: 0 !important"
              >
                <div style="display: flex">
                  <el-upload
                    class="upload-demo"
                    action="#"
                    style="margin-left: 10px"
                    :http-request="uploadFile"
                    :auto-upload="true"
                    accept=".xlsx, .xls"
                    :show-file-list="false"
                  >
                    <el-button type="primary" @click="submissionTypeC(4)"
                      >EO Form Excel</el-button
                    >
                  </el-upload>

                  <el-button 
                    type="primary" 
                    style="margin-left: 10px" 
                    class="upload-demo" 
                    @click="handleOpenBatchUploadModel()"
                  >
                    Batch Upload - Files
                  </el-button>
                </div>
              </div>
            </div>
            </template>
            
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="showBatchUploadModel"
        width="50%"
        :before-close="handleCloseBatchUploadModel"
      >
        <el-upload
          class="upload-demo"
          action="#"
          ref="upload"
          style="margin-left: 10px"
          :http-request="uploadBatchUpload"
          :multiple="true"
          :auto-upload="false"
          accept=".doc, .pdf, .mp4, .docx , .mov"
          :show-file-list="false"
          :onProgress='handleUploadProgress'
          :on-change="handleUploadChange"
          :file-list="batchUploadFileList"
        >
            <el-button slot="trigger" size="small" type="primary" :disabled="allowChoose">Choose</el-button>
            <div class="upload-btn-wrap">
              <el-button 
                  style="margin-left: 10px;" 
                  size="small" 
                  type="success" 
                  :disabled='!allowUpload'
                  @click="uploadBatchUploadFile"
                >
                    Upload File
                </el-button>
                <div class="error-count">{{'Error：' + errorCount}}</div>
            </div>
        </el-upload>
        <el-table :data="batchUploadFileList" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }">
          <!--file={uploadCode,fileType,status,size,name}-->
            <el-table-column type="index" label="S/N" fixed width="60">
            </el-table-column>
            <el-table-column prop="uploadCode" label="Entry Number">
            </el-table-column>
            <el-table-column prop="name" label="Name">
            </el-table-column>
            <el-table-column prop="fileType" label="Type">
            </el-table-column>
            <el-table-column prop="size" label="Size">
              <template slot-scope="scope">
                <div>{{((scope.row.size-scope.row.size%1024)/1024/1024).toFixed(2) +' MB'}}</div>
              </template>
            </el-table-column>
            <el-table-column  label="Status">
              <template slot-scope="scope">
                <div :style="scope.row.isError?'color:red;':''">{{scope.row | errOrStatusShow}}</div>
                <el-progress v-if="!scope.row.isError" :percentage="scope.row.percent>0?Number(scope.row.percent.toFixed(0)):0" :format="() =>{return ''}" :text-inside='true'></el-progress>
              </template>
            </el-table-column>
            <el-table-column  label="Action"> 
              <template slot-scope="scope">
                <el-button :disabled="scope.row.percent>0 && scope.row.percent<100" type="danger" icon="el-icon-delete" size="mini" @click="handleBatchUploadDeleteFile(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios"
import draggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  components: {
    draggable
  },
  filters: {
    errOrStatusShow: (row) => {
      if(row.status=='fail'){
        row.isError = row.status
        return row.isError
      }
      if(row.isError) return row.isError
      if(row.percent>0 && row.percent<100) return row.percent.toFixed(0)+'%'
      return row.status
    }
  },
  data() {
    return {
      submissionType: "",
      showBatchUploadModel:false,
      batchUploadFileList:[],
    };
  },
  created() {},
  computed:{
    baseURL(){
      return config.domain+'/'
    },
    allowUpload(){
      const readyList = this.batchUploadFileList.filter(i=>{
        return i.status=='ready' && i.percent == 0
      })
      return readyList.length
    },
    errorCount(){
      const errorList = this.batchUploadFileList.filter(i=>{
        return i.isError
      })
      return errorList.length
    },
    allowChoose(){
       const loadingList = this.batchUploadFileList.filter(i=>{
        return i.percent != 0 && i.percent != 100
      })

      return !!loadingList.length
    }
  },
  methods: {
    handleUploadProgress(e){
      this.batchUploadFileList[e.fileIndex].percent=e.percent
    },
    submissionTypeC(submissionType) {
      this.submissionType = submissionType;
    },
    async uploadFile(params) {
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.stemupUpload;
      obj.submissionType = this.submissionType;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$message({
        message: "Upload Success",
        type: "success",
      });
    },
    async uploadBatchUploadFile(){
        this.$refs.upload.submit();
    },

    async uploadBatchUpload(params){
      let uploadParams = params
      const res = await this.getUploadParams()
      uploadParams.uploadParams=res
      this.$forceUpdate()
      const OSSres =await this.uploadFileToOSS(uploadParams,params)
      this.$forceUpdate()
      const submitRes = await this.submitFileData(uploadParams,OSSres)
      if(submitRes.status_code!=0){
        const file=this.batchUploadFileList.find(i=>{
        return i.name==uploadParams.file.name
        })
      file.isError=submitRes.status_message
      }
    },
    async getUploadParams(){
      let userInfo = this.getAuthObj();
      let result = await axios.get(this.baseURL+'stemup/getUploadUrl', {
　　    params: { 
          'userId': userInfo.userId ,
          'token': userInfo.token
        }
      })
      return result.data
    },
    async uploadFileToOSS(uploadParams,fileObj){
      let fileIndex = 0
      const file=this.batchUploadFileList.find((i,index)=>{
        fileIndex=index
        return i.name==uploadParams.file.name
      })
      const key=uploadParams.uploadParams.dir + "/" + file.uploadCode + '/' + file.uploadCode + (new Date()).valueOf() + '.' + file.fileType
      const formData = new FormData();
      formData.append('name',uploadParams.file.name)
      formData.append('key',key)
      formData.append('policy',uploadParams.uploadParams.policy)
      formData.append('OSSAccessKeyId',uploadParams.uploadParams.accessid)
      formData.append('success_action_status','200')
      formData.append('callback',uploadParams.uploadParams.callback || '')
      formData.append('signature',uploadParams.uploadParams.signature)
      formData.append('file',fileObj.file)

      const res =await axios.post(uploadParams.uploadParams.host,formData,{
        onUploadProgress: progressEvent => {
        let percent=(progressEvent.loaded / progressEvent.total * 100) || 0
        this.$refs.upload.onProgress({percent:percent,fileIndex})
      },
        headers:{
          Accept: "application/json, text/plain, */*",
          isNotShowLoading:true
      }
    })
      return {res,key}
    },
    async submitFileData(uploadParams,OSSres){
      const userInfo = this.getAuthObj();
      const file=this.batchUploadFileList.find(i=>{
        return i.name==uploadParams.file.name
      })
      const params={
        userId: userInfo.userId ,
        token: userInfo.token,
        uploadCode: file.uploadCode,
        title: '',
        reportFile:file.isMovie?'':OSSres.key,
        movieFile:file.isMovie?OSSres.key:'',
        description: '',
        memberNo: ''
      }
      const submitRes=await axios.post(this.baseURL +'stemup/submit', params)
      return submitRes.data
    },
    handleUploadChange(file, fileList){
      //选择文件 
      //file={uploadCode,fileType,status,size,name,percent}
      if(file.status=='ready'){
        const size=(file.size/1024/1024).toFixed(2)
        const splitNameList=file.name.split("_")
        const uploadCode=splitNameList[0]
        const fileTypeFromName=splitNameList.length>1?splitNameList[1].split(".")[0]:''
        const fileTypeFromSuffix=splitNameList.length>1?splitNameList[1].split(".")[1]:''
        const fileType=fileTypeFromSuffix
        let isMovie=true
        let isError=false
        fileTypeFromName=='a'?isMovie=false:isMovie=true
        if(size>100){
          file.status='The upload file size cannot be larger than 100MB'
          isError='The upload file size cannot be larger than 100MB'
        }
        if(!(uploadCode&&(fileTypeFromName=='a'||fileTypeFromName=='b'))){
          file.status='Naming format error'
          isError='Naming format error'
        }
        this.batchUploadFileList.unshift({...file,uploadCode,fileType,isMovie,isError,percent:0})
      }
    },
    handleCloseBatchUploadModel(done) {
      done();
    },
    handleOpenBatchUploadModel() {
      this.showBatchUploadModel=true
    },
    handleBatchUploadDeleteFile(index){
      this.batchUploadFileList.splice(index,1)
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
  .title{
    position: relative;
    width:100%;
    height:100px;
    margin:80px 0 40px;
    .content-wrap{
      position:absolute;
      top:0;
      left:-20px;
      width:calc(100% + 70px);
    }
  }
  .upload-btn-wrap{
    display:flex;
    flex:1;
    justify-content: space-between;
    align-items: flex-end;
    .error-count{
      margin-right:35px;
      font-weight: 600;
    }
  }

  ::v-deep .upload-demo{
    display:flex;
    margin-bottom:10px;
  }

  ::v-deep .el-table__body-wrapper{
    min-height:300px;
  }
</style>
